var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1331",
    "data-name": "Group 1331",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1018",
    "data-name": "Rectangle 1018",
    width: 21,
    height: 21,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1330",
    "data-name": "Group 1330",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M20.288,2.488,18.512.712A2.416,2.416,0,0,0,16.793,0H1.67A1.672,1.672,0,0,0,0,1.67V19.33A1.672,1.672,0,0,0,1.67,21H19.33A1.672,1.672,0,0,0,21,19.33V4.207a2.416,2.416,0,0,0-.712-1.72M14.882.935v3.8a.6.6,0,0,1-.6.6H6.745a.6.6,0,0,1-.6-.6V.935ZM4.246,20.065V12.009a1.019,1.019,0,0,1,1.018-1.018h10.5a1.019,1.019,0,0,1,1.018,1.018v8.056Zm15.818-.735a.736.736,0,0,1-.735.735H17.716V12.009a1.955,1.955,0,0,0-1.953-1.953H5.264a1.955,1.955,0,0,0-1.953,1.953v8.056H1.67a.736.736,0,0,1-.735-.735V1.67A.736.736,0,0,1,1.67.935H5.21v3.8A1.536,1.536,0,0,0,6.745,6.267h7.538a1.536,1.536,0,0,0,1.535-1.535V.935h.976a1.487,1.487,0,0,1,1.058.438l1.775,1.775a1.487,1.487,0,0,1,.438,1.058Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M278.5,37h-.484a.226.226,0,0,0-.226.226V39.58a.226.226,0,0,0,.226.226h.484a.226.226,0,0,0,.226-.226V37.226A.226.226,0,0,0,278.5,37",
    transform: "translate(-264.795 -35.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M186.5,290.22l-.406-.406a.181.181,0,0,0-.256,0l-1.133,1.133a.181.181,0,0,1-.256,0l-1.133-1.133a.181.181,0,0,0-.256,0l-.406.406a.181.181,0,0,0,0,.256l1.133,1.133a.181.181,0,0,1,0,.256L182.657,293a.181.181,0,0,0,0,.256l.406.406a.181.181,0,0,0,.256,0l1.133-1.133a.181.181,0,0,1,.256,0l1.133,1.133a.181.181,0,0,0,.256,0l.406-.406a.181.181,0,0,0,0-.256l-1.133-1.133a.181.181,0,0,1,0-.256l1.133-1.133a.181.181,0,0,0,0-.256",
    transform: "translate(-174.064 -276.209)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.a5cf65387f630e087202f6e26ed0d489.svg";
export { ForwardRef as ReactComponent };